"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point2dSizeNormalizer = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Normalizes the arbitrary data point size into a screen space display size.
 */
class Point2dSizeNormalizer {
    constructor(pixelSizeRange) {
        this.pixelSizeRange = pixelSizeRange;
        this.tmpRange = pixelSizeRange.slice();
        this.sizeRange = pixelSizeRange.slice();
        this.sizeRange.update(Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY);
        this.transform = this.sizeRange.getRangeTransform(this.pixelSizeRange);
        this.requiresInitialization = true;
    }
    getSizeToPixelTransform() {
        DEBUG_MODE && rc_js_util_1._Debug.assert(Boolean(this.debugHasRange), "range not initialized");
        if (this.requiresInitialization) {
            this.sizeRange.getRangeTransform(this.pixelSizeRange, this.transform);
            this.requiresInitialization = false;
        }
        return this.transform;
    }
    extendDataRange(min, max) {
        DEBUG_MODE && rc_js_util_1._Debug.runBlock(() => this.debugHasRange = true);
        this.tmpRange.update(min, max);
        this.sizeRange.unionRange(this.tmpRange, this.sizeRange);
        this.requiresInitialization = true;
    }
}
exports.Point2dSizeNormalizer = Point2dSizeNormalizer;
//# sourceMappingURL=t-point2d-size-normalizer-trait.js.map